/* Brazil Motif SVG Accent for About Section Titles */
export default function BrazilAccentSVG({ style = {}, ...props }) {
  return (
    <svg width="120" height="32" viewBox="0 0 120 32" fill="none" style={{ position:'absolute', left:'50%', top:0, transform:'translateX(-50%)', zIndex:0, ...style }} {...props}>
      <ellipse cx="60" cy="16" rx="58" ry="10" fill="#F5C84C" fillOpacity="0.18" />
      <ellipse cx="60" cy="20" rx="48" ry="7" fill="#14B88D" fillOpacity="0.13" />
      <ellipse cx="60" cy="24" rx="36" ry="4" fill="#5FC9A8" fillOpacity="0.11" />
    </svg>
  );
}
